export function getChipStyleByKind(kind: string) {
  let backgroundColor = "#52a869";
  if (kind === "signer") backgroundColor = "#954cd0";
  if (kind === "property") backgroundColor = "#3078d5";

  return {
    color: "white",
    backgroundColor
  };
}